import { DependencyAssociation } from '../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/DependencyAssociation';
import { EnumMultiplicity } from '../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/EnumMultiplicity';
import { EnumRelationshipType } from '../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/EnumRelationshipType';
export class DependencyAssociationExtend {
  public static Init(dto: DependencyAssociation) {
    dto.relationshipType = EnumRelationshipType.Dependency;
    dto.sourceMultiplicity = EnumMultiplicity.ZeroMany;
    dto.targetMultiplicity = EnumMultiplicity.ZeroOne;
    dto.sourceIsNavigation = false; // 源不能导航，只需要设置目标对应的属性即可。
  }
}
